import createHistory from "history/createHashHistory";

export const history = createHistory();



// WEBPACK FOOTER //
// ./src/support/history.js